var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "footer",
    { ref: "footer", staticClass: "footer w1200", attrs: { id: "footer2" } },
    [
      _c("div", { staticClass: "footermenu" }, [
        _c(
          "div",
          { staticClass: "footermenulist" },
          _vm._l(_vm.ulTittel, function(item) {
            return _c(
              "ul",
              { key: item.id },
              [
                _vm._v("\n        " + _vm._s(item.name) + "\n        "),
                _vm._l(item.link, function(linkItem, index) {
                  return _c(
                    "li",
                    { key: index },
                    [
                      _c("router-link", { attrs: { to: linkItem.url } }, [
                        _vm._v(_vm._s(linkItem.urln))
                      ])
                    ],
                    1
                  )
                })
              ],
              2
            )
          }),
          0
        )
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "footer_menu clearfix" }, [
        _vm._m(0),
        _vm._v(" "),
        _c("div", { staticClass: "copyright_pc" }, [
          _vm._m(1),
          _vm._v(" "),
          _c("div", { staticClass: "copyright_pcout" }, [
            _c(
              "a",
              {
                staticClass: "copyright_pcTitle",
                staticStyle: { color: "#939393" },
                attrs: {
                  href:
                    "http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=33010802011728",
                  target: "_blank"
                }
              },
              [
                _c("img", {
                  staticStyle: {
                    width: "20px",
                    height: "20px",
                    "margin-bottom": "4px"
                  },
                  attrs: {
                    src: _vm.$imageUrl + "/pcImages/ztimg/safety.png",
                    alt: ""
                  }
                }),
                _vm._v("浙公网安备 33010802011728号")
              ]
            ),
            _vm._v(" "),
            _c(
              "a",
              {
                staticClass: "copyright_pcTitle",
                staticStyle: { color: "#939393" },
                attrs: {
                  href: "https://beian.miit.gov.cn/#/Integrated/recordQuery",
                  target: "_blank"
                }
              },
              [
                _vm._v("\n          浙ICP备2021039685号"),
                _vm.envNODE_ENV === "test"
                  ? _c("span", [_vm._v("-1")])
                  : _vm._e(),
                _vm.envNODE_ENV === "production"
                  ? _c("span", [_vm._v("-2")])
                  : _vm._e()
              ]
            ),
            _vm._v(" "),
            _vm._m(2)
          ])
        ])
      ])
    ]
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "clearfix" }, [
      _c("div", { staticClass: "fr", staticStyle: { display: "none" } })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("p", [_vm._v("\n        浙江正泰智维能源服务有限公司"), _c("br")])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "a",
      {
        staticClass: "copyright_pcTitle",
        staticStyle: { color: "#939393" },
        attrs: {
          href:
            "http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=33010802011728",
          target: "_blank"
        }
      },
      [
        _vm._v("经营许可证编号 浙B2"),
        _c("span", { staticClass: "outSpan" }, [_c("span", [_vm._v("-")])]),
        _vm._v("20230032-")
      ]
    )
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-6ba7fdc8", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6ba7fdc8","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/footernav.vue
// module id = Z0un
// module chunks = 129